import React from "react";
import styled from "styled-components";

import { IThemeProps } from "@/styles";
import { HEXtoRGBA } from "@/styles/helper";

type FormButtonProps = {
  type: string;
  label: string;
  disabled: boolean;
  className?: string;
  onClick: () => void;
  fullWidth?: boolean;
  dataQA?: string;
};

class FormButton extends React.PureComponent<FormButtonProps> {
  public static defaultProps: FormButtonProps = {
    type: "button",
    label: "Call to Action",
    disabled: false,
    onClick: () => null,
    dataQA: "FormButton",
  };

  constructor(props: FormButtonProps) {
    super(props);
  }

  public render(): JSX.Element {
    const {
      label,
      disabled,
      className,
      onClick,
      fullWidth,
      dataQA,
    } = this.props;
    return (
      <Wrapper className={className}>
        <Button
          data-qa={dataQA}
          disabled={disabled}
          onClick={onClick}
          fullWidth={fullWidth}
        >
          {label}
        </Button>
      </Wrapper>
    );
  }
}

export default FormButton;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

type ButtonProps = IThemeProps<{
  fullWidth?: boolean;
  disabled?: boolean;
}>;
export const Button = styled.div<ButtonProps>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px auto;
  text-align: center;
  vertical-align: middle;
  height: 41px;
  line-height: 41px;
  width: 100%;
  max-width: ${(props: ButtonProps) => (props.fullWidth ? "100%" : "350px")};
  font-size: ${(props: ButtonProps) => props.theme.typography.h400};
  border-radius: ${(props: ButtonProps) => props.theme.borders.buttonRadius};
  color: ${(props: ButtonProps) => props.theme.colors.buttonText};
  background-color: ${(props: ButtonProps) => props.theme.colors.button};
  letter-spacing: 0.2px;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: 600;
  ${(props: ButtonProps) =>
    `border: ${props.theme.borders.button} solid ${
      props.theme.thesis.hasButtonInvert
        ? props.theme.colors.button
        : HEXtoRGBA(props.theme.colors.white, 0.3)
    }`};
  transition: all 250ms ease-in-out;
  svg {
    path {
      fill: ${(props: ButtonProps) => props.theme.colors.buttonText};
      transition: all 250ms ease-in-out;
    }
  }

  a {
    color: ${(props: ButtonProps) => props.theme.colors.buttonText};
  }

  ${({ theme: { globals, colors, thesis } }: ButtonProps) =>
    !globals.isTouch &&
    `&:hover {
      svg {
        path {
          fill: ${
            thesis.hasButtonInvert ? colors.button100 : colors.buttonText
          };
        }
      }
      color: ${thesis.hasButtonInvert ? colors.button100 : colors.buttonText};
      background-color: ${
        thesis.hasButtonInvert ? colors.white : colors.button100
      };

      a {
        color: ${thesis.hasButtonInvert ? colors.button100 : colors.buttonText};
      }
    }`}

  ${(props: ButtonProps) =>
    props.disabled && `opacity: 0.5; pointer-events: none;`}
`;
